import React from 'react';
import PropTypes from 'prop-types';
import { convertDateReviewPage } from '../helpers';

const AttestationReview = ({ data, editPage }) => {
  const name = data.attestationName;
  const date = convertDateReviewPage(data.attestationDate);

  return (
    <div className="form-review-panel-page">
      <div className="form-review-panel-page-header-row">
        <h4 className="form-review-panel-page-header vads-u-font-size--h5">
          Attestation of Hours Transferred
        </h4>
        <va-button
          secondary
          class="edit-page float-right"
          onClick={editPage}
          label="Edit Attestation of Hours Transferred"
          text="Edit"
        />
      </div>
      <dl className="review">
        <div className="review-row">
          <dt>
            <p className="vads-u-margin-bottom--2">
              By signing here I acknowledge the following,
            </p>
            <p className="vads-u-margin-bottom--2">
              I have transferred fewer than 12 credits (or its equivalent in
              clock hours) from my program at the closed/disapproved facility;
              and
            </p>
            <p>
              If I am transferred 12 or more credits (or its equivalent in clock
              hours) from such program at a later date, the Secretary will
              rescind/revoke my restored entitlement
            </p>
          </dt>
          <dd />
        </div>
        <div className="review-row">
          <dt>Your Full Name</dt>
          <dd className="dd-privacy-hidden" data-dd-action-name="data value">
            <strong>{name}</strong>
          </dd>
        </div>
        <div className="review-row">
          <dt>Date</dt>
          <dd>{date}</dd>
        </div>
      </dl>
    </div>
  );
};

AttestationReview.propTypes = {
  data: PropTypes.object,
  editPage: PropTypes.func,
};

export default AttestationReview;
